<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AHc31T/html/images/cover.jpg?1684245186123" alt="This image is the cover for the book Collaborative Process Automation Systems"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Collaborative Process Automation Systems
      </h1>
      <p class="bookDescription body article font2">
        <p>Providing a comprehensive overview of the state-of-the-art in Collaborative Process Automation Systems (CPAS), this book discusses topics such as engineering, security, enterprise connectivity, advanced process control, plant asset management, and operator efficiency. Collaborating with other industry experts, the author covers the system architecture and infrastructure required for a CPAS, as well as important standards like OPC and the ISA-95 series of standards. This in-depth reference focuses on the differences between a CPAS and traditional automation systems. Implications on modern automation systems are outlined in theory and practice. This book is ideal for industrial engineers, as well as graduate students in control and automation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Hollender
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ISA
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e5fc7296